/**
 * Copyright © Veeam Software Group GmbH.
 */

import styled from 'styled-components';

export const SpinnerPlateStyled = styled.div`
    align-items: center;
    background-color: transparent;
    display: flex;
    height: 100%;
    justify-content: center;
    width: 100%;
`;
